export default {"src":"/_next/static/media/content_event_online_event.4307ad2b.svg","height":500,"width":750,"blurWidth":0,"blurHeight":0};